export {default} from './EditPromoteListing';



// WEBPACK FOOTER //
// ./src/pages/EditPromoteListing/index.ts